module.exports = __webpack_public_path__ + "img/go_search_small.d4f48879.svg";